import { useEffect, useState } from "react";
import api from "@/lib/api";
import { formatRelative } from "@/lib/format";
import { History, CheckCircle2 } from "lucide-react";
import EmptyState from "@/components/EmptyState";

export default function AgentHistoryPage() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/checkin/history").then((r) => setItems(r.data)).finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="z-container" style={{ textAlign: "center" }}><span className="z-loader z-loader-dark" /></div>;

  return (
    <div className="z-container" data-testid="agent-history-page">
      <h1 className="z-page-title">Historique des scans</h1>
      <p className="z-page-sub">Vos 50 derniers contrôles.</p>

      {items.length === 0 ? (
        <EmptyState icon={<History size={28} />} title="Aucun scan effectué" message="Les billets validés apparaîtront ici." testId="agent-history-empty" />
      ) : (
        <div style={{ display: "grid", gap: 8 }}>
          {items.map((it) => (
            <div key={it.id} className="z-card" style={{ padding: 14, display: "flex", alignItems: "center", gap: 12 }} data-testid={`scan-log-${it.id}`}>
              <CheckCircle2 size={20} color="var(--z-success)" />
              <div style={{ flex: 1 }}>
                <div style={{ fontWeight: 600 }}>{it.event_title || "Événement inconnu"}</div>
                <div style={{ fontSize: 12, color: "var(--z-muted)" }}>
                  {formatRelative(it.scanned_at)} · Réf. {it.ticket_id.slice(-8)}
                </div>
              </div>
              <span className="z-badge z-badge-success">OK</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
